// extracted by mini-css-extract-plugin
export default {"nav":"bottomNav_nav__4xO3w"};